var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"nopadding"},[_c('v-container',{staticClass:"nopadding",attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('Breadcrumb',{attrs:{"items":_vm.items}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }